import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import {
  MutationStatus,
  MutationUpdateTenantAccountEmailPreferencesArgs,
  UpdateTenantAccountEmailPreferencesInput,
} from '../gql-types.generated';
import { getStandardHeaders } from '../util/StandardRequestHeaders';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPDATE_TENANT_ACCOUNT_EMAIL_PREFERENCES = gql`
  mutation updateTenantAccountEmailPreferences($input: UpdateTenantAccountEmailPreferencesInput!) {
    updateTenantAccountEmailPreferences(input: $input) {
      code
      message
      error
    }
  }
`;

export const mutationUpdateTenantAccountEmailPreferences = async (
  client: ApolloClient<NormalizedCacheObject>,
  options: UpdateTenantAccountEmailPreferencesInput,
): Promise<MutationStatus | undefined> => {
  const { disableMerchantReceipt, disablePayerReceipt } = options;
  const headers = await getStandardHeaders();
  const { data, errors } = await client.mutate<
    { updateTenantAccountEmailPreferences: MutationStatus },
    MutationUpdateTenantAccountEmailPreferencesArgs
  >({
    variables: { input: { disableMerchantReceipt, disablePayerReceipt } },
    mutation: MUTATION_UPDATE_TENANT_ACCOUNT_EMAIL_PREFERENCES,
    context: {
      headers,
    },
  });
  if (errors && errors.length > 0) {
    errors.forEach(error => {
      // Log error details in the console.
      console.error(error);
    });
    // Friendly error to the user.
    throw new Error('An error has occurred while updating email preferences.');
  }

  if (data && data.updateTenantAccountEmailPreferences) {
    return data.updateTenantAccountEmailPreferences;
  }

  return undefined;
};
